import { Service } from 'typedi';
import { TokenType } from '../../../models/enums/general-enums';
import { IRegistrationAutoLoginModel } from '../models';
import { AutoLoginDataBuilder } from './autologindata.builder.service';

@Service()
export class RegistrationAutoLoginDataBuilder extends AutoLoginDataBuilder<IRegistrationAutoLoginModel> {
    public Build = async (data: any): Promise<IRegistrationAutoLoginModel> => {
        let loginModel: IRegistrationAutoLoginModel = {
            AuthenticationInfo: JSON.stringify({
                TokenData: {
                    TokenType: TokenType.Regular,
                    TokenValue: decodeURIComponent(data.UserInfo),
                },
            }),
            EncryptionType: String(data?.EncryptionType ?? ''),
            SourceProductPackage: data.SourceProductPackage,
            ClientVersion: this._window.pageContextManager.getDeviceData().clientVersion,
            TargetProductPackage: this._window.pageContextManager.getDeviceData().productPackage,
            TargetSubBrand: this._window.pageContextManager.getBrandData().subBrandId,
            BrandID: this._window.pageContextManager.getBrandData().brandId,
            ...(this.shouldSendLoginCountry() && {
                LoginCountryISO3: this._window.pageContextManager.getGlobalizationData().country,
            }),
        };

        loginModel = await this._setLoginNativeProps(loginModel);
        return loginModel;
    };
}
